import { Button } from "@jkast90/kast-common/ui";
import { useState } from "react";
import { useWorkspace } from "@workspace/hooks/useReduxWorkspace";
import { GroupSelectDialog } from "@groups/components";
import WorkspaceSelector from "./WorkspaceSelector";

/**
 * What the Links, Notes and Workspace pages show when no workspace
 * (dashboard) is selected: the workspace selector, a line saying so, and a button that opens the
 * picker dialog.
 */
export default function NoWorkspaceSelected() {
  const { workspaces, setSelectedWorkspace } = useWorkspace();
  const [open, setOpen] = useState(false);

  return (
    <div style={{ textAlign: "center", padding: "2rem 1rem" }}>
      <WorkspaceSelector />
      <p>No dashboard selected</p>
      <Button variant="primary" onClick={() => setOpen(true)}>
        Select dashboard
      </Button>
      <GroupSelectDialog
        open={open}
        onClose={() => setOpen(false)}
        groups={workspaces}
        title="Select a Dashboard"
        emptyMessage="No dashboards available"
        onSelectGroup={setSelectedWorkspace}
      />
    </div>
  );
}
